import { IChatMessage } from 'types/chat';

export const queue = (array: string[] | number[], item: string, length: number): any => {
  if (array.length >= length) {
    const result = [...array, item];
    return result.slice(-length);
  }
  return [...array, item];
};

export const messagesQueue = (array: IChatMessage[], item: IChatMessage) => {
  if (array.length === 50) {
    const result = [...array, item];
    return result.slice(1);
  }
  return [...array, item];
};
